export const MASTERBASEURL = 'https://master.bossstudio.tv';
export const BASEURL = '';
export const SOCKET_BASEURL = '';
export const DIGITAL_SIGN_SOCKET_BASEURL = 'https://digisignsocket.bossstudio.tv';